export const Field = ({ label, required, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="field-label">{label}{required && <span className="text-red-500"> *</span>}</span>
    {children}
  </label>
);

export const TextInput = ({ label, required, value, onChange, testid, className, ...rest }) => (
  <Field label={label} required={required} className={className}>
    <input className="field" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest} />
  </Field>
);

export const SelectInput = ({ label, required, value, onChange, options, testid, placeholder = "Selecione", className }) => (
  <Field label={label} required={required} className={className}>
    <select className="field" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      <option value="">{placeholder}</option>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  </Field>
);

export const TextArea = ({ label, required, value, onChange, testid, rows = 3, className, ...rest }) => (
  <Field label={label} required={required} className={className}>
    <textarea className="field resize-y" rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest} />
  </Field>
);

export const Toggle = ({ label, checked, onChange, testid }) => (
  <button type="button" onClick={() => onChange(!checked)} data-testid={testid} aria-pressed={checked}
    className={`flex items-center justify-between gap-3 border px-3 py-2.5 text-sm transition-colors ${checked ? "border-red-600 bg-red-950/30 text-white" : "border-[#273248] bg-[#0B0F17] text-slate-300 hover:border-slate-500"}`}>
    {label}
    <span className={`relative h-5 w-9 rounded-full transition-colors ${checked ? "bg-red-600" : "bg-slate-700"}`}>
      <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform ${checked ? "translate-x-4" : "translate-x-0.5"}`} />
    </span>
  </button>
);
